import React from 'react'
import { ComplianceFramework } from '@trustero/trustero-api-web/lib/audit/framework_pb'
import { useComplianceFrameworks } from 'src/components/async/complianceframework'
import { useComplianceFrameworkObjectives } from 'src/components/async/Framework/useComplianceFrameworkObjectives'
import { FilterName, FilterParam } from '../FilterBar.types'
import { NONE_VALUE } from '../FilterBar.constants'
import { FilterDropdown } from './FilterDropdown'
import { NestedFilterType } from './FilterDropdown.constants'
import { LoadingFilterDropdown } from './FilterDropdown.components'

export const ComplianceFrameworkFilterDropdown = React.memo(
  ({ isNested = false }: { isNested?: boolean }): JSX.Element | null => {
    const {
      data: cfData,
      isLoading: cfLoading,
      error: cfError,
    } = useComplianceFrameworks(true)

    const complianceFrameworks = cfData?.getItemsList() || []
    const cfIds = complianceFrameworks?.map((cf) => cf.getId())
    const {
      data: requirementsData,
      isLoading: requirementsLoading,
      error: requirementsError,
    } = useComplianceFrameworkObjectives(cfIds)
    if (cfError || requirementsError) return <></>
    if (cfLoading || requirementsLoading) {
      return (
        <LoadingFilterDropdown
          filterName={FilterName.COMPLIANCE_FRAMEWORK}
          isNested={isNested}
        />
      )
    }

    const cfFilterNameToNestedFilter: Record<string, NestedFilterType> = {}
    complianceFrameworks.forEach((cf) => {
      const requirements =
        requirementsData
          ?.getItemsList()
          .filter(
            (objective) => objective.getComplianceFrameworkId() === cf.getId(),
          ) || []
      if (requirements && requirements.length > 0) {
        const nestedFilter: NestedFilterType = {
          filterParam: cf.getModelId(),
          filterValues: [
            NONE_VALUE,
            ...requirements.map((requirement) => ({
              value: requirement.getModelId(),
              label: requirement.getName(),
            })),
          ],
          hasSearch: true,
        }
        cfFilterNameToNestedFilter[cf.getName()] = nestedFilter
      }
    })

    const filterValues = [
      NONE_VALUE,
      ...complianceFrameworks.map((cf: ComplianceFramework) => {
        return {
          value: cf.getModelId(),
          label: cf.getName(),
          nestedFilter: cfFilterNameToNestedFilter[cf.getName()],
        }
      }),
    ]

    return complianceFrameworks.length > 0 ? (
      <FilterDropdown
        filterParam={FilterParam.COMPLIANCE_FRAMEWORK}
        filterName={FilterName.COMPLIANCE_FRAMEWORK}
        filterValues={filterValues}
        hasNested
        parentMeansAll
        isNested={isNested}
      />
    ) : null
  },
)
